import React from "react";
import {Switch,Route} from 'react-router-dom'
import asyncComponent from "../../../util/asyncComponent"; 

const Reports =({match})=>(
    <Switch>
          <Route  path={`${match.url}/AssetReport`} component={asyncComponent(()=>import( './AssetReport/index'))} />
    </Switch>
)
export default Reports;